import Layout from "@/components/layout/Layout";
import React from "react";
import Content from "@/components/layout/Content";
import ContentOptions from "@/components/layout/ContentOptions";
import Heading from "@/components/elements/Heading";
import Sidepanel from "@/components/layout/Sidepanel";
import { InertiaLink } from "@inertiajs/inertia-react";
import DashboardMenu from "@/pages/Dashboard/DashboardMenu";

/**
 * Users Dashboard Component
 *
 * Displays a table of all system users with their basic information.
 * Provides navigation to create new users and edit existing ones.
 * Part of the admin dashboard interface for user management.
 *
 * @param {Object} props - Component props
 * @param {Array} props.users - Array of user objects to display
 * @param {Object} props.users[] - Individual user object
 * @param {string} props.users[].id - User ID
 * @param {string} props.users[].name - User's full name
 * @param {string} props.users[].email - User's email address
 * @param {string} props.users[].customercode - Associated customer account number
 *
 * @returns {JSX.Element} The rendered users dashboard page
 */
export default function Users({ users }) {
    return (
        <Layout>
            <Sidepanel>
                <DashboardMenu active={"Gebruikers"} />
            </Sidepanel>
            <Content>
                <ContentOptions small>
                    <Heading heading={"Gebruikers"} />
                </ContentOptions>
                <div
                    className={`contentoptions ingaveoptions col-md-9 d-flex flex-column`}
                >
                    <Heading heading="Gebruikers">
                        <div>
                            <a
                                name={"Nieuwe gebruiker"}
                                href="/dashboard/users/new"
                                className="btn-orange"
                            >
                                Nieuwe gebruiker
                            </a>
                        </div>
                    </Heading>

                    <table className="table tablecustom">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th>Email</th>
                                <th>Accountno</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user, key) => {
                                return (
                                    <tr key={key}>
                                        <td>{user.name}</td>
                                        <td>{user.email}</td>
                                        <td>{user.customercode}</td>
                                        <th>
                                            <InertiaLink
                                                name="Aanpassen"
                                                href={`/dashboard/users/edit/${user.id}`}
                                                className={"mr-2"}
                                            >
                                                <svg
                                                    fill="currentColor"
                                                    viewBox="0 0 20 20"
                                                    height="20"
                                                >
                                                    <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            </InertiaLink>
                                        </th>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Content>
        </Layout>
    );
}
